import styled from 'styled-components/macro';
import { StyledPageHd } from '../../Themes';

export const Title = styled(StyledPageHd)`
  @media (max-width: ${({ theme }) => theme.device.mobileL}px) {
    margin: 0 0 1.5rem 1.5rem;
    font-size: calc(1.2em + 1vw);
  }
`;
